var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "node-installation" },
    [
      _c(
        "el-form",
        { staticClass: "search-form", attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            [
              _vm.activeLang.executable_name === "python"
                ? _c("el-autocomplete", {
                    staticClass: "search-box",
                    staticStyle: { width: "240px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: _vm.$t("Search Dependencies"),
                      "fetch-suggestions": _vm.fetchAllDepList,
                      minlength: 2
                    },
                    on: { select: _vm.onSearch, clear: _vm.onSearch },
                    model: {
                      value: _vm.depName,
                      callback: function($$v) {
                        _vm.depName = $$v
                      },
                      expression: "depName"
                    }
                  })
                : _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: _vm.$t("Search Dependencies") },
                    model: {
                      value: _vm.depName,
                      callback: function($$v) {
                        _vm.depName = $$v
                      },
                      expression: "depName"
                    }
                  })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    icon: "el-icon-search",
                    type: "success"
                  },
                  on: { click: _vm.onSearch }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-checkbox", {
                attrs: { label: _vm.$t("Show installed") },
                on: { change: _vm.onIsShowInstalledChange },
                model: {
                  value: _vm.isShowInstalled,
                  callback: function($$v) {
                    _vm.isShowInstalled = $$v
                  },
                  expression: "isShowInstalled"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.onTabChange },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        _vm._l(_vm.langList, function(lang) {
          return _c("el-tab-pane", {
            key: lang.name,
            attrs: { label: lang.name, name: lang.executable_name }
          })
        }),
        1
      ),
      _vm.activeLang.install_status === "installed"
        ? [
            !["python", "node"].includes(_vm.activeLang.executable_name)
              ? [
                  _c(
                    "div",
                    { staticClass: "install-wrapper" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-check",
                            disabled: "",
                            type: "success"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Installed")) + " ")]
                      )
                    ],
                    1
                  )
                ]
              : [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      attrs: {
                        height: "calc(100vh - 280px)",
                        data: _vm.computedDepList,
                        "empty-text": _vm.depName
                          ? _vm.$t("No Data")
                          : _vm.$t("Please search dependencies"),
                        border: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("Name"),
                          prop: "name",
                          width: "180"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: !_vm.isShowInstalled
                            ? _vm.$t("Latest Version")
                            : _vm.$t("Version"),
                          prop: "version",
                          width: "100"
                        }
                      }),
                      !_vm.isShowInstalled
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("Description"),
                              prop: "description"
                            }
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("Action") },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  !scope.row.installed
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: _vm.getDepLoading(scope.row)
                                              ? "el-icon-loading"
                                              : "",
                                            disabled: _vm.getDepLoading(
                                              scope.row
                                            ),
                                            size: "mini",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickInstallDep(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Install")) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: _vm.getDepLoading(scope.row)
                                              ? "el-icon-loading"
                                              : "",
                                            disabled: _vm.getDepLoading(
                                              scope.row
                                            ),
                                            size: "mini",
                                            type: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickUninstallDep(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Uninstall")) +
                                              " "
                                          )
                                        ]
                                      )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2908536074
                        )
                      })
                    ],
                    1
                  )
                ]
          ]
        : _vm.activeLang.install_status === "installing"
        ? [
            _c(
              "div",
              { staticClass: "install-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-loading",
                      disabled: "",
                      type: "warning"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Installing")) + " ")]
                )
              ],
              1
            )
          ]
        : _vm.activeLang.install_status === "installing-other"
        ? [
            _c(
              "div",
              { staticClass: "install-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: "el-icon-close",
                      disabled: "",
                      type: "warning"
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Other language installing")) + " "
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm.activeLang.install_status === "not-installed"
        ? [
            _c(
              "div",
              { staticClass: "install-wrapper" },
              [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("This language is not installed yet.")))
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { icon: "el-icon-check", type: "primary" },
                    on: { click: _vm.onClickInstallLang }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Install")) + " ")]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }